<template>
  <BreadCrumb PageTitle="Niveles" PageParent="Juegos" parentRoute="/game-list"/>
  <LevelList :axios="$axios"/>
</template>

<script lang="ts">
import {defineComponent} from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import LevelList from "../../components/Levels/LevelList/LevelList.vue";

export default defineComponent({
  name: "LevelsListPage",
  components: {
    BreadCrumb,
    LevelList,
  }
});
</script>